import {useContext, useMemo, useState} from 'react';
import {Button, Divider, Form} from 'antd';
import {infoFields /* passwordFields */} from './profileForm';
import {FixedLengthArray} from 'components/formItems/FormGroup/FormGroup';
import FormGroup from 'components/formItems/FormGroup';
import CandidateMainCard from 'components/CandidateStatusCards/MainCard';
import StudentMainCard from 'components/StudentStatusCards/MainCard';
import SERVICES from 'services';
import Toast from 'components/Toast';
import './Profile.less';
import {AuthContext} from 'context/Auth.context';
import Loading from 'components/FullScreenLoading';
import {CandidateContext} from 'context/Candidate.context';
import {StudentContext} from 'context/Student.context';

const validateMessages = {
	required: 'Դաշտը պարտադիր է:',
	types: {
		email: '${label} անվավեր է:',
		number: '${label} վավեր թիվ չէ:'
	}
};

const Profile = () => {
	const [infoForm] = Form.useForm();

	const {state: candidateState} = useContext(CandidateContext);

	const {state: studentState} = useContext(StudentContext);

	const {
		state: {student}
	} = useContext(AuthContext);

	const role = student ? 'STUDENT' : 'CANDIDATE';

	const state = role === 'STUDENT' ? studentState : candidateState;
	//@ts-ignore
	const {name, [role === 'STUDENT' ? 'lastName' : 'lastname']: lastname, middleName, telephone} = state;

	// const [passwordForm] = Form.useForm();

	const [formErrors] = useState<any>({});

	const [infoEditMode, setInfoEditMode] = useState(false);

	// const [passwordEditMode, setPasswordEditMode] = useState(false);

	const getInfoFields = useMemo(() => {
		if (!infoEditMode) {
			return infoFields.map(field => ({
				...field,
				disabledAt: ['ADD', 'EDIT'] as FixedLengthArray<['ADD' | 'EDIT', ('ADD' | 'EDIT')?]>
			}));
		}
		return infoFields;
	}, [infoEditMode]);

	// const getPasswordFields = useMemo(() => {
	// 	if (!passwordEditMode) {
	// 		return [
	// 			{
	// 				...passwordFields[0],
	// 				disabledAt: ['ADD', 'EDIT'] as FixedLengthArray<['ADD' | 'EDIT', ('ADD' | 'EDIT')?]>
	// 			}
	// 		];
	// 	}
	// 	return passwordFields;
	// }, [passwordEditMode]);

	const onInfoSubmit = (values: any) => {
		SERVICES.USER.patchCandidate(values).then(res => {
			Toast.success(res);
		});
	};

	// const onPasswordChange = (values: any) => {};

	if (!name && !lastname && !middleName && !telephone) return <Loading />;

	return (
		<div className="container">
			{role === 'CANDIDATE' ? (
				<CandidateMainCard isProfile={true} />
			) : (
				<StudentMainCard showExternalInfo />
			)}

			<Form
				onFinish={onInfoSubmit}
				form={infoForm}
				layout="vertical"
				validateMessages={validateMessages}
				className="profile-info"
				initialValues={{name, lastname, middleName, telephone}}>
				<div className="form-header">
					<h1 className="form-title">Անձնական Տվյալներ</h1>
					<div className="actions">
						{/* <span className="hint">
							ⓘ Տվյալները խմբագրման ենթակա են միայն մինչև ընդունելության դիմում-հայտ ուղարկելը
						</span>
						<Button
							className="edit"
							type="primary"
							onClick={() => setInfoEditMode(true)}
							icon={<PencilSimple size={18} weight="fill" />}>
							Խմբագրել
						</Button> */}
					</div>
				</div>
				<Divider style={{borderColor: '#002494'}} />
				<div className="form-steps">
					<div className="steps-content">
						<FormGroup tabFields={getInfoFields} formErrors={formErrors} visible={'EDIT'} />
						{infoEditMode && (
							<div className="edit-actions">
								<div key="submit">
									<Button
										className="main-btn"
										size="large"
										onClick={() => {
											infoForm.resetFields();
											setInfoEditMode(false);
										}}>
										Չեղարկել
									</Button>
								</div>

								<div key="submit">
									<Button
										className="main-btn"
										size="large"
										type="primary"
										onClick={infoForm.submit}>
										Հաստատել
									</Button>
								</div>
							</div>
						)}
					</div>
				</div>
			</Form>

			{/* <Form
				onFinish={onPasswordChange}
				form={passwordForm}
				layout="vertical"
				validateMessages={validateMessages}
				className="profile-info"
				initialValues={formInitialValues}>
				<div className="form-header">
					<h1 className="form-title">Անվտանգություն</h1> */}
			{/* <div className="actions">
						<Button
							className="edit"
							type="primary"
							onClick={() => setPasswordEditMode(true)}
							icon={<PencilSimple size={18} weight="fill" />}>
							Խմբագրել
						</Button>
					</div> */}
			{/* </div>
				<Divider style={{borderColor: '#002494'}} />
				<div className="form-steps">
					<div className="steps-content">
						<FormGroup tabFields={getPasswordFields} formErrors={formErrors} visible={'EDIT'} />
						{passwordEditMode && (
							<div className="edit-actions">
								<div key="submit">
									<Button
										className="main-btn"
										size="large"
										onClick={() => {
											passwordForm.resetFields();
											setPasswordEditMode(false);
										}}>
										Չեղարկել
									</Button>
								</div>

								<div key="submit">
									<Button
										className="main-btn"
										size="large"
										type="primary"
										onClick={passwordForm.submit}>
										Հաստատել
									</Button>
								</div>
							</div>
						)}
					</div>
				</div>
			</Form> */}
		</div>
	);
};

export default Profile;
